var React = require('react');

function Divider3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,0 C6.83050094,50 15.1638343,75 25,75 C41.4957514,75 62.4956597,0 81.2456597,0 C93.7456597,0 99.9971065,0 100,0 L100,100 L0,100"}));
}

Divider3.defaultProps = {"width":"100%","height":"96px","viewBox":"0 0 100 100","version":"1.1","preserveAspectRatio":"none"};

module.exports = Divider3;

Divider3.default = Divider3;
